var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.998 7.78C6.729 6.345 9.198 5 12 5C14.802 5 17.27 6.345 19.002 7.78C19.7852 8.42152 20.4888 9.15439 21.098 9.963C21.351 10.307 21.563 10.645 21.716 10.96C21.856 11.246 22 11.618 22 12C22 12.382 21.855 12.754 21.716 13.04C21.54 13.39 21.3332 13.7237 21.098 14.037C20.4888 14.8456 19.7852 15.5785 19.002 16.22C17.271 17.655 14.802 19 12 19C9.198 19 6.73 17.655 4.998 16.22C4.21482 15.5785 3.51116 14.8456 2.902 14.037C2.66682 13.7237 2.46 13.39 2.284 13.04C2.144 12.754 2 12.382 2 12C2 11.618 2.145 11.246 2.284 10.96C2.437 10.645 2.649 10.307 2.902 9.963C3.51116 9.15439 4.21482 8.42152 4.998 7.78ZM12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15Z",
    fill: "#D1FE17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseEye);
export default __webpack_public_path__ + "static/media/icon_closeEye.f9141f3118415ba822c26924e283a26d.svg";
export { ForwardRef as ReactComponent };